import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Flex } from '@grupoboticario/flora-react';
import { FadeIn } from 'ui/components';

import config from 'config';
import { getReturnUrl } from '../../../core/utilities/helpers/get-return-url';

import { Form, Logo, InfoUtilLinks, NotificationMultbrand, SecurityUtilLinks } from './components';
import Styles from './Login.styles';
import { useLoginBanners } from './hooks/useLoginBanners';

import { BUSINESS_UNITS, user } from 'core';
import { useDispatch } from 'react-redux';
import { getAccessToken } from '../../../core/services/auth/get-access-token/get-access-token';
import { useRedirectToHome } from 'ui/hooks/useRedirectToHome';

export const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { redirectToHome } = useRedirectToHome();
  const { data: banners } = useLoginBanners();
  const haveBothBanners = banners?.image1?.url && banners?.image2?.url;
  const isEud = config.app.short === BUSINESS_UNITS.EUD.toLowerCase();

  const accessToken = getAccessToken();

  useEffect(() => {
    const pathUrl = getReturnUrl();
    if (pathUrl) {
      history.push(pathUrl);
    }
  }, []);

  useEffect(() => {
    if (accessToken) {
      dispatch(user.actions.userFetch.request());
      redirectToHome();
    }
  }, []);

  return (
    <Styles.Wrapper data-autotagging-flora-section="login" data-brand={config.app.short}>
      <Container size="small">
        <Styles.BannersWrapper>
          {haveBothBanners ? (
            <FadeIn direction="left">
              <Styles.Banner
                src={banners?.image1?.url}
                alt={banners?.image1?.alt}
                data-testid="banner"
              />
            </FadeIn>
          ) : null}
          <Styles.Card>
            <FadeIn direction="up" delay={100}>
              <Flex direction="column">
                <Logo />

                <NotificationMultbrand />

                <Form />

                <InfoUtilLinks />

                <SecurityUtilLinks />
              </Flex>
            </FadeIn>
          </Styles.Card>
          {haveBothBanners ? (
            <FadeIn direction="right">
              <Styles.Banner src={banners?.image2?.url} alt={banners?.image2?.alt} />
            </FadeIn>
          ) : null}
        </Styles.BannersWrapper>
      </Container>
      <Styles.LogoGrupoBoticario
        alt="logo do grupo boticário"
        src={isEud ? '/images/logo-grupoboticario-black.svg' : '/images/logo-grupoboticario.svg'}
      />
    </Styles.Wrapper>
  );
};

export default Login;
